module.exports = __webpack_public_path__ + "static/media/logo.7bcdde5e.svg";